import { useAppContext } from '@/Main';
import { Offcanvas } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import type { ReactNode } from 'react';
import { hideDrawer } from '../reducers/drawer';

type DrawerWrapperProps = {
  title: ReactNode;
  children?: ReactNode;
  show: boolean;
  onHide?: () => void;
  width?: number | string;
};

const DrawerWrapper = ({
  title,
  children,
  show,
  onHide,
  width = 1300
}: DrawerWrapperProps) => {
  const {
    config: { isDark }
  } = useAppContext();
  const dispatch = useDispatch();

  return (
    <Offcanvas
      className="drawer-wrapper-offcanvas"
      onShow={() => {
        const offcanvasElement = document.querySelector('.drawer-wrapper-offcanvas');
        if (offcanvasElement) {
          offcanvasElement.removeAttribute('tabindex');
        }
      }}
      show={show}
      onHide={() => {
        onHide?.();
        dispatch(hideDrawer());
      }}
      style={{ backgroundColor: 'var(--falcon-body-bg)' }}
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title as="div" className="flex-grow-1 min-w-0">
          {title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <hr className="my-0" />
      <Offcanvas.Body className="pb-5 pt-0">{children}</Offcanvas.Body>
      <style>
        {`
          .drawer-wrapper-offcanvas {
            width: ${typeof width === 'number' ? `${width}px` : width} !important;
            max-width: 100% !important;
          }
          .drawer-wrapper-offcanvas strong {
            color: inherit !important;
          }
          .drawer-wrapper-offcanvas img {
            margin: 0 auto;
            border-radius: 5px;
            box-shadow: ${isDark ? '#19232f 3px -3px 3px 0px, #19232f -3px 3px 3px 0px' : 'var(--falcon-box-shadow)'};
            max-width: 100%;
            height: auto;
            display: flex;
          }
        `}
      </style>
    </Offcanvas>
  );
};

export default DrawerWrapper;
